<template>
  <hm-content title="收银设置">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="名称：" prop="textName">
        <el-input
          size="small"
          placeholder="请输入名称"
          v-model="ruleForm.textName"
        ></el-input>
      </el-form-item>
      <el-form-item label="内容放置位置：">
        <el-radio-group v-model="ruleForm.locationType" size="small">
          <el-radio label="front">前置</el-radio>
          <el-radio label="end">后置</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="图文详情：" prop="textContent">
        <hm-rich-editor
          v-model="ruleForm.textContent"
          :html="ruleForm.textContent"
        />
      </el-form-item>
      <el-form-item label="跳转链接：">
        <div class="flex item-center">
          <span class="mr10">类型</span>
          <el-radio-group
            v-model="ruleForm.linkType"
            @change="switchLinkType"
            class="flex-1"
          >
            <el-radio label="page">页面</el-radio>
            <el-radio label="goods">商品</el-radio>
            <el-radio label="brand">品牌</el-radio>
            <el-radio label="mp">小程序</el-radio>
          </el-radio-group>
        </div>
        <template v-if="ruleForm.linkType === 'page'">
          <div class="flex">
            <span class="mr10">链接</span>
            <div class="flex-1">
              <el-select
                class="flex-1"
                size="small"
                clearable
                placeholder="选择页面"
                v-model="linkContent.pageInfo.linkUrl"
                @change="selectGroup"
                filterable
              >
                <el-option
                  v-for="(item, index) in microShopRouteList"
                  :key="index"
                  :label="item.hrefName"
                  :value="item.hrefAddress"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="flex item-center"
            v-if="linkContent.groupGoodsInfo.groupId"
          >
            <span>分组：</span>
            <el-tag closable @close="handleCloseGroup" type="success">{{
              linkContent.groupGoodsInfo.groupName
            }}</el-tag>
          </div>
        </template>
        <div class="flex item-center" v-if="ruleForm.linkType === 'goods'">
          <span class="mr10">商品</span>
          <el-tag
            closable
            v-if="linkContent.goodsInfo.wxshopSpuName"
            @close="handleClose('goodsVisible')"
            type="success"
            >{{ linkContent.goodsInfo.wxshopSpuName }}</el-tag
          >
          <el-button v-else type="text" @click="goodsVisible = true"
            >添加商品</el-button
          >
        </div>
        <div class="flex item-center" v-if="ruleForm.linkType === 'brand'">
          <span class="mr10">品牌</span>
          <el-tag
            closable
            v-if="linkContent.brandInfo.brandName"
            @close="handleClose('brandVisible')"
            type="success"
            >{{ linkContent.brandInfo.brandName }}</el-tag
          >
          <el-button v-else type="text" @click="goodsVisible = true"
            >添加品牌</el-button
          >
        </div>
        <template v-if="ruleForm.linkType === 'mp'">
          <div class="flex item-center mb20">
            <span class="mr10">appid</span>
            <el-input
              size="small"
              v-model="linkContent.mpInfo.appid"
              type="text"
              placeholder="请输入appid"
            ></el-input>
          </div>
          <div class="flex item-center">
            <span style="width: 34px" class="mr10">链接</span>
            <el-input
              v-model="linkContent.mpInfo.linkUrl"
              size="small"
              type="text"
              placeholder="请输入链接"
            ></el-input>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="是否展示：">
        <el-switch
          size="mini"
          class="transfer-switch"
          v-model="ruleForm.textType"
          active-value="master"
          inactive-value="slave"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>
      <el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="save('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="backPrev">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
    <hm-filter-brand
      @saveBrand="saveBrand"
      @close="brandVisible = false"
      :visible="brandVisible"
    ></hm-filter-brand>
    <hm-filter-micro-shop-goods
      type="microShop"
      :visible="goodsVisible"
      :radio="true"
      @setLink="setLink"
      @close="goodsVisible = false"
    ></hm-filter-micro-shop-goods>
    <hm-filter-group-goods
      @saveGroupGoods="saveGroupGoods"
      @close="groupGoodsVisible = false"
      :visible="groupGoodsVisible"
    ></hm-filter-group-goods>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import HmFilterBrand from "@/components/HmFilterBrand";
import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";

export default {
  name: "cahierSetting",
  components: {
    HmRichEditor,
    HmFilterBrand,
    HmFilterMicroShopGoods,
    HmFilterGroupGoods
  },
  computed: {
    ...mapState({
      goodsBaseInfo: state => state.goodsLib.goodsBaseInfo
    }),
    ...mapGetters(["microShopRouteList"])
  },
  data() {
    return {
      brandVisible: false,
      goodsVisible: false,
      groupGoodsVisible: false,
      linkContent: {
        goodsInfo: {
          wxshopSpuName: ""
        },
        brandInfo: {
          wxshopSpuName: ""
        },
        mpInfo: {
          appid: "",
          linkUrl: ""
        },
        pageInfo: {
          linkUrl: ""
        },
        groupGoodsInfo: {}
      },
      ruleForm: {
        locationType: "front",
        textName: "",
        textType: "master",
        textContent: "",
        linkType: ""
      },
      id: "",
      rules: {
        textName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        textContent: [
          {
            required: true,
            message: "请输入图文详情",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.queryDetails();
    }
    this.$store.dispatch("queryMicroShopList", {
      linkType: "page"
    });
  },
  methods: {
    async queryDetails() {
      const { result } = await this.$store.dispatch(
        "queryGoodsBaseInfoDetails",
        {
          id: this.id
        }
      );
      if (result) {
        for (let key in result) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = result[key];
          }
        }
      }
      if (result.linkContent) {
        this.linkContent = JSON.parse(result.linkContent);
      }
    },
    async save(formName) {
      console.log(this.linkContent);
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const actionName = this.id ? "editGoodsBaseInfo" : "addGoodsBaseInfo";
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.id) {
          Object.assign(params, {
            id: this.id,
            linkContent: JSON.stringify(this.linkContent)
          });
        }
        await this.$store.dispatch(actionName, params);
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.$router.back();
      }
    },
    saveBrand(data) {
      this.brandVisible = false;
      this.linkContent.brandInfo = data;
    },
    setLink(data) {
      this.goodsVisible = false;
      this.linkContent.goodsInfo = data;
    },
    saveGroupGoods(data) {
      this.groupGoodsVisible = false;
      this.linkContent.groupGoodsInfo = data;
    },
    switchLinkType(e) {
      switch (e) {
        case "goods":
          this.goodsVisible = true;
          break;
        case "brand":
          this.brandVisible = true;
          break;
        default:
          break;
      }
      this.resetLinkContent();
    },
    selectGroup(e) {
      if (e === "groupGoods") {
        this.groupGoodsVisible = true;
      }
    },
    handleCloseGroup() {
      this.resetLinkContent();
    },
    handleClose(type) {
      this.resetLinkContent();
      this[type] = true;
    },
    resetLinkContent() {
      this.linkContent = {
        goodsInfo: {
          wxshopSpuName: ""
        },
        brandInfo: {
          wxshopSpuName: ""
        },
        mpInfo: {
          appid: "",
          linkUrl: ""
        },
        pageInfo: {
          linkUrl: ""
        },
        groupGoodsInfo: {}
      };
    }
  }
};
</script>
